export default "__VITE_ASSET__CffT1aZB__"